import styled, { css } from 'styled-components';
import { compose, space, width } from 'styled-system';
import { buttonStyles } from '../Button/Button';
import { applyVariations, getPaletteColor } from '../utils/utils';
const variations = {
  fill: css(["&:hover{text-decoration:none;}", ""], buttonStyles),
  subtle: css(["", " &:hover{text-decoration:none;background-color:", ";}"], buttonStyles, getPaletteColor('background.tint')),
  link: css(["cursor:pointer;text-decoration:none;color:", ";&:hover{color:", ";text-decoration:underline;}"], getPaletteColor('base'), getPaletteColor('dark')),
  outline: css(["&:hover{text-decoration:none;}", ""], buttonStyles),
  plain: css(["", " &:hover{text-decoration:none;background-color:", ";}"], buttonStyles, getPaletteColor('background.base')),
  white: css(["", " &:hover{text-decoration:none;background-color:", ";}"], buttonStyles, getPaletteColor('background.base')),
  lightFill: css(["", " ", ""], buttonStyles, props => {
    return props.disabled ? `
        background-color: ${getPaletteColor('background.base')(props)};
        color: ${getPaletteColor('text.light')(props)};` : '';
  }),
  input: css(["", " text-align:center;", ""], buttonStyles, props => {
    return props.disabled ? `
        background-color: ${getPaletteColor('background.base')(props)};
        color: ${getPaletteColor('text.light')(props)};` : '';
  })
};
/**
 * @public
 */
export const Link = /*#__PURE__*/styled.a.attrs(({
  color,
  disabled,
  href,
  target,
  onClick,
  ...props
}) => ({
  color: disabled ? 'text.light' : color,
  disabled,
  href: !disabled ? href : undefined,
  rel: target === '_blank' ? 'noopener' : null,
  target,
  onClick: !disabled ? onClick : () => {},
  ...props
})).withConfig({
  displayName: "Link",
  componentId: "sc-1eidvea-0"
})(["", " ", " ", ""], applyVariations('Link', variations), props => props.disabled && `
    cursor: default;

    &:hover {
      text-decoration: none;
    }
  `, props => compose(space, width)(props));
Link.displayName = 'Link';
Link.defaultProps = {
  color: 'primary',
  variation: 'link',
  size: 'medium'
};